import React from 'react';

const getRankingBadge = (index) => {
  if (index === 0) return '🥇';
  if (index === 1) return '🥈';
  if (index === 2) return '🥉';
  return '▪️';
};

export const PainelAdminMetricasTab = ({ metrics, projects, rankedVendedores }) => {
  if (!metrics) {
    return null;
  }

  return (
    <>
      <div className="flex items-center gap-3 mb-6">
        <span className="text-4xl">📈</span>
        <div>
          <h2 className="text-2xl font-bold text-gray-900" data-testid="painel-admin-metricas-title">Métricas do Sistema</h2>
          <p className="text-gray-600">Visão geral do desempenho</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="painel-admin-metricas-cards">
        <div className="bg-blue-50 rounded-xl p-4 text-center" data-testid="painel-admin-metricas-vendedores-card">
          <div className="text-3xl font-bold text-blue-600">{metrics.total_vendedores}</div>
          <div className="text-sm text-gray-600">Vendedores</div>
        </div>
        <div className="bg-green-50 rounded-xl p-4 text-center" data-testid="painel-admin-metricas-ativos-card">
          <div className="text-3xl font-bold text-green-600">{metrics.vendedores_ativos}</div>
          <div className="text-sm text-gray-600">Ativos</div>
        </div>
        <div className="bg-purple-50 rounded-xl p-4 text-center" data-testid="painel-admin-metricas-leads-card">
          <div className="text-3xl font-bold text-purple-600">{metrics.total_leads}</div>
          <div className="text-sm text-gray-600">Total Leads</div>
        </div>
        <div className="bg-orange-50 rounded-xl p-4 text-center" data-testid="painel-admin-metricas-projetos-card">
          <div className="text-3xl font-bold text-orange-600">{projects.length}</div>
          <div className="text-sm text-gray-600">Projetos</div>
        </div>
      </div>

      <div className="mt-6" data-testid="painel-admin-ranking-section">
        <h3 className="font-semibold mb-3">Ranking de Vendedores</h3>
        <div className="space-y-2" data-testid="painel-admin-ranking-list">
          {rankedVendedores.map((v, idx) => (
            <div key={v.id} className="flex items-center gap-3 p-2 bg-gray-50 rounded-lg" data-testid={`painel-admin-ranking-item-${v.id}`}>
              <span className="text-lg">{getRankingBadge(idx)}</span>
              <span className="flex-1">{v.nome}</span>
              <span className="font-semibold">{v.leads_count || 0} leads</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
